<template>
    <div class="passenger-feedback-carousel-wrapper">
        <a class="page-link" @click="prevItem">
            <img src="/imgs/icons/passenger-feedback-arrow-left.webp">
        </a>
        <carousel
            :autoplay="autoplay"
            autoplay-hover-pause
            :per-page="1"
            :pagination-enabled="false"
            :autoplay-timeout="3000"
            center-mode
            loop
            @input="index = !!$event ? $event : index"
            :navigate-to="index"
        >
            <slide v-for="(entry, index) in entries" :key="index">
                <div class="passenger-feedback-carousel-item">
                    &ldquo;<span v-html="entry.html_text" />&rdquo;
                </div>
            </slide>
        </carousel>
        <a class="page-link" @click="nextItem">
            <img src="/imgs/icons/passenger-feedback-arrow-right.webp">
        </a>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    components: {
        Carousel,
        Slide,
    },

    props: {
        jsonEntries: String,
    },

    data() {
        return {
            index: 0,
            autoplay: true,
        };
    },

    computed: {
        entries() {
            return JSON.parse(this.jsonEntries);
        },
    },

    methods: {
        prevItem() {
            if (this.index > 0) {
                this.index -= 1;
            } else {
                this.index = this.entries.length - 1;
            }
            this.autoplay = false;
        },
        nextItem() {
            if (this.index < this.entries.length - 1) {
                this.index += 1;
            } else {
                this.index = 0;
            }
            this.autoplay = false;
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PassengerFeedbackCarousel.vue